import { render, staticRenderFns } from "./RealNameReport.vue?vue&type=template&id=34a6cc94&scoped=true"
import script from "./RealNameReport.vue?vue&type=script&lang=js"
export * from "./RealNameReport.vue?vue&type=script&lang=js"
import style0 from "./RealNameReport.vue?vue&type=style&index=0&id=34a6cc94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a6cc94",
  null
  
)

export default component.exports